import { Keys, Scene } from "excalibur";
import { goToScene } from "../../main";
import { gameState, inventoryState } from "../../state/stateManager";
import { createGainedItem, sendAlert } from "../../utils";
import { Resources } from "../../Resources";

export default class Feeding extends Scene {
  onActivate() {
    this.feeding = document.getElementById("feeding");
    this.feeding.classList.add("activeMenu");
    this.menu = document.getElementById("feeding-menu");
    this.menu.classList.add("activeMenuMenu");
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      goToScene("onlineMarket");
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Space)) {
      console.log("buy; pressed space");
      let coins = gameState.getCoins();

      if (coins >= 10) {
        console.log("have enough coins, should buy");
        let inventory = inventoryState.getInventory();
        inventory.sugar = inventory.sugar + 10;
        gameState.setCoins(coins - 10);
        Resources.Coins.play();
        createGainedItem("10lbs Sugar");
        console.log("buy sugar");
      } else {
        Resources.Error.play();
        sendAlert("You Do Not Have Enough Coins");
      }
    }
  }
  onDeactivate() {
    this.feeding.classList.remove("activeMenu");
    this.menu.classList.remove("activeMenuMenu");
  }
}
